import { connect } from 'react-redux';
import { Map } from 'immutable';

import decorate from '../../utils/decorate';

import { request as createRequest } from '../../modules/roles/actions/create';

import CreateRoleModal from './CreateRoleModal.jsx';

const STATE_KEY = 'create-user-modal';

function mapStateToProps(state, props) {
    return {
        permissions: state.permissions.getIn([ 'items' ], Map())
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        onCreateRoleRequest: userData => dispatch(createRequest(userData))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    CreateRoleModal
);
